import { render, staticRenderFns } from "./Riskmatrixcategories.vue?vue&type=template&id=8640dbcc&scoped=true"
import script from "./Riskmatrixcategories.vue?vue&type=script&lang=js"
export * from "./Riskmatrixcategories.vue?vue&type=script&lang=js"
import style0 from "./Riskmatrixcategories.vue?vue&type=style&index=0&id=8640dbcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8640dbcc",
  null
  
)

export default component.exports